/**
 * Helper centralizado para acesso a variáveis de ambiente.
 *
 * Em runtime (produção/homologação), as variáveis são injetadas via window.__ENV__
 * pelo server/index.js antes de iniciar o Express.
 *
 * Em desenvolvimento local, as variáveis são injetadas via Webpack DefinePlugin
 * (process.env.REACT_APP_*) a partir do .env.
 *
 * O fallback garante compatibilidade: window.__ENV__ tem prioridade sobre process.env.
 */
export const getEnv = (key: string): string =>
  window.__ENV__?.[key] ?? process.env[key] ?? ''
